import { downloadFolderZip } from '@/api/document.api';

export const saveFolderZip = async (folderId: number, name: string) => {
  const response = await downloadFolderZip(folderId);
  const url = URL.createObjectURL(response.data);
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `${name.replace(/[\\/:*?"<>|\x00-\x1f]/g, '_') || 'folder'}.zip`;
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
  }
};
